import React from "react";
import LocalizedLink from "modules/layout/components/LocalizedLink";
import { findPageIdByFilePath } from "modules/common/utils/findPageIdByFilePath";
import DOMRenderer from "modules/layout/components/DOMRenderer";
import { FormattedDate, useIntl } from "react-intl";

const ReleaseListItem = ({ release }) => {
  const releasePageId = findPageIdByFilePath("/releases/:slug");
  const { date, version, summary } = release;
  const { formatMessage } = useIntl();
  return (
    <LocalizedLink page={{ pageId: releasePageId, pathname: version }}>
      <div className="br-9 pt-3 d-flex flex-column theme-teaser box-shadow justify-content-start">
        <div className="px-3 color-blue-4">{version}</div>
        <h3 className="px-3 pb-1 my-2 font-weight-500">
          <FormattedDate
            value={date}
            year="numeric"
            month="long"
            day="numeric"
          />
        </h3>
        <DOMRenderer className="px-3 py-1 opacity-78" htmlString={summary} />
        <span className="color-blue-4 link-hover p-3 d-block border-top">
          {formatMessage({
            id: "go-to-detail",
            defaultMessage: "Zu den Details",
          })}{" "}
          →
        </span>
      </div>
    </LocalizedLink>
  );
};

export default ReleaseListItem;
